import type { GlobalPermission } from "@superagents/types/api";
import { useSectorPermissions } from "./useSectorPermissions";

export function usePermission(permission: GlobalPermission): boolean {
  const { permissions } = useSectorPermissions();
  return permissions.includes(permission);
}
